module.exports = __webpack_public_path__ + "assets/img/3_1215_big.67661c3e.jpg";